import { render, staticRenderFns } from "./TriggerTarget.vue?vue&type=template&id=24d0ddd8&scoped=true"
import script from "./TriggerTarget.vue?vue&type=script&lang=js"
export * from "./TriggerTarget.vue?vue&type=script&lang=js"
import style0 from "./TriggerTarget.vue?vue&type=style&index=0&id=24d0ddd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0ddd8",
  null
  
)

export default component.exports